import { Component, OnInit, Input } from '@angular/core';
import { WorkspaceService } from '../services/workspace.service';
import { ThemeSettingService } from '../services/theme-setting.service';

@Component({
  selector: 'app-web-content',
  templateUrl: './web-content.component.html',
  styleUrls: ['./web-content.component.css']
})
export class WebContentComponent implements OnInit {

  private componentId: string;
  embedLink: string;
  isBusy: boolean;
  loaderConfig: any;
  constructor(private workspaceService: WorkspaceService, private themeSettingService: ThemeSettingService) { }

  ngOnInit() {
    this.loaderConfig = this.themeSettingService.getTheme();
  }

  @Input() set setComponentId(id: string){
    if (id){
      this.componentId = id;
      this.isBusy = true;
      this.workspaceService.getWebContentCard(id).subscribe(result => {
        this.isBusy = false;
        if (result){
          this.embedLink = JSON.parse(result).EmbedLink;
        }
      }, error => {
        this.isBusy = false;
      })
    }

  }

}
